import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { connect } from "react-redux";
import {
  Login,
  Register,
  UserDashboard,
  HomePage,
  Main,
  ForgetPassword,
  SubmitURL,
  Post,
  Footer,
  TopTenLikes
} from "./components";
import { WebStorage, WebStorageNames } from "./utils";
import * as AccontAction from "./components/domain/accounts/accountActions";
import HowToSubmit from "./components/domain/howToSubmit/howtoSubmit";
import { bindActionCreators } from "redux";
import PrivacyPolicy from "./components/domain/privacyPolicy/privacyPolicy";
import TermsAndConditions from "./components/domain/termsAndConditions/termsAndConditions";
import ContactUs from "./components/domain/contactUs/contactUsForm";
import MoreBookmarks from "./components/domain/moreBookmarks/moreBookmarks";

class Routes extends Component {
  constructor(props) {
    super(props);
    let isUserloggedIn = WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    this.state = {
      isLoggedIn: isUserloggedIn,
      value: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    let isUserloggedIn = WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    if (isUserloggedIn) {
      this.setState({
        isLoggedIn: true
      });
    } else {
      this.setState({
        isLoggedIn: false
      });
    }
  }

  getLocalUserInfo() {
    return WebStorage.getLocalStore(WebStorageNames.UserInfo);
  }
  authenticate(SuccessComponent, FailComponentName) {
    const { isLoggedIn } = this.state;
    const loggedUser = this.getLocalUserInfo();
    if (loggedUser || isLoggedIn) {
      return <SuccessComponent />;
    }
    return <Redirect to={FailComponentName} />;
  }

  notAuthenticate(SuccessComponentName, FailComponent) {
    const { isLoggedIn } = this.state;
    const loggedUser = this.getLocalUserInfo();
    return loggedUser || isLoggedIn ? (
      <Redirect to={SuccessComponentName} />
    ) : (
      <FailComponent />
    );
  }
  render() {
    let { isLoggedIn } = this.state;
    const { accountActions, isLoading } = this.props;
    return (
      <Router>
        <div>
          <Main
            IsUserLoggedIn={isLoggedIn}
            onLogOut={accountActions.onLogOut}
            isLoading={isLoading}
          >
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route exact path="/topTenLikes" component={TopTenLikes} />
              <Route
                path="/post/:id/:websiteTitle"
                render={props => <Post {...props} isLoggedIn={isLoggedIn} />}
              />

              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/more-bookmarks" component={MoreBookmarks} />
              <Route
                path="/terms-and-conditions"
                component={TermsAndConditions}
              />
              <Route path="/contact-us" component={ContactUs} />
              <Route path="/how-to-submit" component={HowToSubmit} />
              <Route
                path="/userDashboard"
                render={props => {
                  return isLoggedIn ? (
                    <UserDashboard {...props} />
                  ) : (
                    <Redirect to="/" />
                  );
                }}
              />

              <Route
                path="/register"
                render={() => this.notAuthenticate("/userDashboard", Register)}
              />
              <Route
                path="/login"
                render={() => this.notAuthenticate("/userDashboard", Login)}
              />

              <Route
                path="/forgetPassword"
                render={() =>
                  this.notAuthenticate("/forgetPassword", ForgetPassword)
                }
              />

              <Route
                path="/submitURL"
                render={() => this.authenticate(SubmitURL, "/login")}
              />
            </Switch>
          </Main>
          <Footer />
        </div>
      </Router>
    );
  }
}

const mapStateToProps = ({ userAccount }) => {
  const { isLoggedIn, isLoading } = userAccount;
  return {
    isLoggedIn,
    isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(AccontAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
